var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.016 8.89h-5.81V2C8.193 2.383 2.385 8.125 2 15.18h6.74v-4.157h-.767V7.961h3.07v3.063h-.768v9.953h.712v.766h10.029v-.766h.767V16.82l-6.576-.054v-6.344h5.809v.93h3.068V7.96h-3.068v.93zM7.918 20.978v3.062h3.07v-.767h4.219V30C8.137 29.617 2.384 23.82 2 16.766h6.74v4.156l-.822.055zm13.043 2.296v.766h3.07v-3.063h-.767V16.82h6.74C29.62 23.875 23.811 29.617 16.742 30v-6.727h4.22z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrq);
export default __webpack_public_path__ + "static/media/PRQ.3a8f37942e16b3ff0eccc2c3cc928338.svg";
export { ForwardRef as ReactComponent };